<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <div>
        <div v-if='btns.add'>
          <button :title='$t("MCS.addGroup")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("add")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-add e-icons"></span>
          </button>
        </div>
        <div v-if='btns.mod'>
          <button :title='$t("MCS.modGroup")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("mod")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-edit e-icons"></span>
          </button>
        </div>
        <div v-if='btns.del'>
          <button :title='$t("MCS.del")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("del")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-remove e-icons"></span>
          </button>
        </div>
<!--        <div v-if='btns.groupCall'>-->
<!--          <button :title='$t("MCS.cell")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("groupArea")' data-ripple="true" tabindex="-1" style="width: auto;">-->
<!--            <span class="e-btn-icon icon hero-icon hero-icon-village e-icons"></span>-->
<!--          </button>-->
<!--        </div>-->
        <div v-if='btns.groupMember'>
          <ejs-dropdownbutton :title='$t("MCS.groupMember")' :items='groupMember' iconCss='icon hero-icon hero-icon-groupmember' :select='dropDownGroupMember'></ejs-dropdownbutton>
        </div>
        <div v-if='btns.export'>
          <ejs-dropdownbutton :title='$t("MCS.export")' :items='exportSelect' iconCss='icon hero-icon hero-icon-export' :select='dropDownExportSelect'></ejs-dropdownbutton>
        </div>
        <div v-if='btns.groupCall'>
          <button :title='$t("MCS.groupCall")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("groupCall")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-gps-groupcall e-icons"></span>
          </button>
        </div>
        <div v-if='btns.refresh'>
          <button :title='$t("MCS.refresh")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("refresh")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-refresh e-icons"></span>
          </button>
        </div>
        <div class="e-toolbar-item e-separator" aria-disabled="false"></div>
        <div v-if='btns.qry'>
          <button :title='$t("MCS.superSearch")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("search")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-search e-icons"></span>
          </button>
        </div>
      </div>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'GroupTableMenu',
  data() {
    return {
      components: {

      },
      btns: {
        add: true,
        mod: true,
        del: true,
        groupMember: true,
        groupCall: true,
        refresh: true,
        qry: true,
        export: false
      },
      groupMember: [
        {
          text: this.$t('MCS.addGroupMember'),
          value: 0
        },
        {
          text: this.$t('MCS.groupMemberManage'),
          value: 1
        }
      ],
      exportSelect: [
        {
          text: this.$t('MCS.groupExport'),
          value: 0
        },
        {
          text: this.$t('MCS.groupMemberExport'),
          value: 1
        }
      ],
      groupArea: [
        {
          text: 'addGroupArea',
          value: 0
        },
        {
          text: 'modGroupArea',
          value: 1
        }
      ],
    };
  },
  methods: {
    buttonClk(args) {
      this.$emit('methodEnum', args);
    },
    dropDownGroupMember(it) {
      if (it.item.value === 0) {
        this.$emit('methodEnum', 'addGroupMember');
      } else if (it.item.value === 1) {
        this.$emit('methodEnum', 'qryGroupMember');
      }
    },
    dropDownExportSelect(it) {
      if (it.item.value === 0) {
        this.$emit('methodEnum', 'groupExport');
      } else if (it.item.value === 1) {
        this.$emit('methodEnum', 'groupMemberExport');
      }
    },
  }
};
</script>

<style scoped>

</style>
